<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6hiovI/tc-custom/9780830897377.jpg?1696870402396" alt="This image is the cover for the book Jeremiah, Lamentations, Ancient Christian Commentary on Scripture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jeremiah, Lamentations, Ancient Christian Commentary on Scripture
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Jeremiah, the weeping prophet, prophesied for four decades under the last five kings of Judah—from 627 to 587 B.C.</strong> His mission: a call to repentance. Among the apostolic fathers, Jeremiah was rarely cited, but several later authors give prominent attention to him, including Origen, Theodoret of Cyr, and Jerome, who wrote individual commentaries on Jeremiah, and Cyril of Alexandria and Ephrem the Syrian, who compiled catenae. Justin and Irenaeus made use of Jeremiah to define Christians over against Jews. Athanasius made use of him in trinitarian debates. Cyril of Jerusalem, Irenaeus, Basil the Great, and Clement of Alexandria all drew on Jeremiah for ethical exhortation. Lamentations, as might be expected, quickly became associated with losses and death, notably in Gregory of Nyssa's<em>Funeral Oration on Meletius</em>. By extension the fathers saw Lamentations as a description of the challenges that face Christians in a fallen world. In this Ancient Christian Commentary on Scripture volume, readers will find some ancient authors translated into English here for the first time. Throughout they will gain insight and encouragement in the life of faith as seen through ancient pastoral eyes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dean O. Wenthe, Thomas C. Oden
      </h2>
      
      <p class="authorDescription body article"><p>Dean O. Wenthe (PhD, Notre Dame) is the president of Concordia Theological Seminary and professor of exegetical theology. He is the general editor of the Concordia Commentary on Scripture series and associate editor of the <em>Concordia Self-Study Bible</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?280663c8